import { request } from '@langlois/request';

export async function getProducts ({ commit }, competitionId) {
	try {
		const url = new URL(`${process.env.VUE_APP_API_URI}/club/competition/${competitionId}/product`);

		const response = await request.get(url);

		if (response.ok) {
			const products = await response.json();

			commit(`setProducts`, { competitionId, products });
		}
	} catch (error) {
		return commit(`vcl/notificationBar/show`, {
			text: `Encountered an error while retrieving the competition's products.`,
			type: `warning`
		}, { root: true });
	}
}
